import { Stack, Avatar, Typography, Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { CardContainerRetro } from "../Container/CardContainerRetro";
import { NavLink } from "react-router-dom";
import { IconThreads } from "../../assets/icon/metric/IconThreads";
import { useIsMobile } from "../../hooks/useIsMobile";

export const CardUser = ({
	user,
}) => {
	const theme = useTheme();
	const isMobile = useIsMobile("sm");
	const profile = user.profile;
	const insight = user.insight?.list;
	const numCollections = user.collectionList?.length || 0;

	return (
		<NavLink
			to={`/user/${profile.id}`}
			style={{ textDecoration: 'none' }}
		>
			<CardContainerRetro 
				w={"100%"} 
				rd={16}
				style={{ 
					cursor: 'pointer'
				}}
			>
				<Stack
					spacing={2}
					sx={{
						padding: isMobile ? theme.spacing(2) : theme.spacing(3),
						width: "100%",
						backgroundColor: theme.palette.background.paper,
					}}
				>
					{/* 프로필 정보 */}
					<Stack direction="row" spacing={2} alignItems="center">
						<Avatar
							src={profile.threads_profile_picture_url}
							sx={{
								width: isMobile ? 48 : 64,
								height: isMobile ? 48 : 64,
								border: `3px solid ${theme.palette.primary.main}`,
							}}
						/>
						<Stack spacing={0.5} sx={{ flex: 1 }}>
							<Typography 
								variant={isMobile ? "h6" : "h5"}
								sx={{
									fontWeight: 700,
									color: theme.palette.text.primary,
									overflow: "hidden",
									display: "-webkit-box",
									WebkitLineClamp: 1,
									WebkitBoxOrient: "vertical",
								}}
							>
								@{profile.username}
							</Typography>
							{profile.name && (
								<Typography 
									variant={isMobile ? "body2" : "body1"}
									sx={{
										color: theme.palette.text.secondary,
										overflow: "hidden",
										display: "-webkit-box",
										WebkitLineClamp: 1,
										WebkitBoxOrient: "vertical",
									}}
								>
									{profile.name}
								</Typography>
							)}
						</Stack>
					</Stack>

					{/* 바이오그래피 */}
					{profile.threads_biography && (
						<Typography 
							variant={isMobile ? "caption" : "body2"}
							sx={{
								color: theme.palette.text.secondary,
								height: isMobile ? "32px" : "40px",
								overflow: "hidden",
								display: "-webkit-box",
								WebkitLineClamp: 2,
								WebkitBoxOrient: "vertical",
							}}
						>
							{profile.threads_biography}
						</Typography>
					)}

					{/* 통계 정보 */}
					<Grid container spacing={1}>
						<Grid size={4}>
							<Stack spacing={0.25} alignItems="center">
								<Stack direction="row" spacing={0.5} alignItems="center">
									<IconThreads size={14} />
									<Typography variant="caption" color="text.secondary">Threads</Typography>
								</Stack>
								<Typography variant={isMobile ? "body2" : "body1"} sx={{ fontWeight: 500 }}>
									{insight?.numThreads || 0}
								</Typography>
							</Stack>
						</Grid>
						<Grid size={4}>
							<Stack spacing={0.25} alignItems="center">
								<Typography variant="caption" color="text.secondary">Collections</Typography>
								<Typography variant={isMobile ? "body2" : "body1"} sx={{ fontWeight: 500 }}>
									{numCollections}
								</Typography>
							</Stack>
						</Grid>
						<Grid size={4}>
							<Stack spacing={0.25} alignItems="center">
								<Typography variant="caption" color="text.secondary">Followers</Typography>
								<Typography variant={isMobile ? "body2" : "body1"} sx={{ fontWeight: 500 }}>
									{insight?.followers?.value || 0}
								</Typography>
							</Stack>
						</Grid>
					</Grid>
				</Stack>
			</CardContainerRetro>
		</NavLink>
	);
}; 